export default {
  state: {
    pageIndex: 1
  },
  mutations: {
    setPageIndex (state, pageIndex) {
      state.pageIndex = pageIndex
    }
  },
  actions: {
    setPageIndex ({state, commit}, pageIndex) {
      commit('setPageIndex', pageIndex)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/pager.js